import React, { memo } from "react";
import InputCustomProp from "./Input";
import DateCustomProp from "./Date";
import SelectCustomProp from "./Select";
import AllocationCustomProp from "./Allocation";
import { ICustomField } from "../types";
import { SelectOptionType } from "app/component/select/Select";

interface Props {
  item: ICustomField;
  props: any;
  value: any;
  isError?: boolean;
  onChange: (
    value: any,
    idObject?: string,
    percentChanged?: boolean,
    deleteKey?: string,
    isAppend?: boolean,
    newSelectValue?: SelectOptionType
  ) => void;
}

const CustomField = memo(({ item, props, value, onChange, isError }: Props) => {
  const {
    permissions,
    isWidget,
    isOrder,
    isEdit,
    changeDependency,
    dataExpense,
    tabIndex,
  } = props;
  const {
    id,
    key,
    parentKey,
    name,
    defaultValue,
    customPropertyId,
    codeName,
    required,
    regexp,
    regexpText,
    isChangeable,
    isSelect,
    isAllocationAvailable,
    isDate,
  } = item;
  const isArray = Array.isArray(defaultValue);
  if (!item || !item.isVisible) return <></>;

  if (isAllocationAvailable) {
    return (
      <AllocationCustomProp
        dataExpense={dataExpense}
        customPropertyId={customPropertyId}
        key={key}
        parentKey={parentKey}
        keyId={key}
        id={id}
        name={name}
        required={required}
        regexp={regexp}
        regexpText={regexpText}
        onChangeDependency={changeDependency}
        changeable={isChangeable}
        permissions={permissions}
        codeName={codeName}
        tabIndex={tabIndex}
        isWidget={isWidget}
        onChange={onChange}
        value={value}
        values={item.values}
        defaultValue={Array.isArray(defaultValue) ? defaultValue : []}
      />
    );
  }

  if (isSelect && !isArray) {
    return (
      <SelectCustomProp
        key={key}
        parentKey={parentKey}
        customPropertyId={customPropertyId}
        id={id}
        keyId={key}
        name={name}
		isError={isError}
        required={required}
        value={value}
        values={item.values}
        onChange={onChange}
        codeName={codeName}
        permissions={permissions}
        regexp={regexp}
        regexpText={regexpText}
        changeable={isChangeable}
        onChangeDependency={changeDependency}
        dataExpense={dataExpense}
        tabIndex={tabIndex}
        isWidget={isWidget}
        defaultValue={defaultValue}
        isOrder={isOrder}
        isEdit={isEdit}
      />
    );
  }

  if (isDate && !isArray) {
    return (
      <DateCustomProp
        keyId={key}
		isError={isError}
        parentKey={parentKey}
        customPropertyId={customPropertyId}
        id={id}
        name={name}
        required={required}
        regexp={regexp}
        regexpText={regexpText}
        changeable={isChangeable}
        permissions={permissions}
        codeName={codeName}
        tabIndex={tabIndex}
        isWidget={isWidget}
        onChange={onChange}
        value={value}
        defaultValue={value}
      />
    );
  }

  return (
    <InputCustomProp
      keyId={key}
      id={id}
	  isError={isError}
      parentKey={parentKey}
      name={name}
      customPropertyId={customPropertyId}
      required={required}
      regexp={regexp}
      regexpText={regexpText}
      changeable={isChangeable}
      codeName={codeName}
      tabIndex={tabIndex}
      isWidget={isWidget}
      permissions={permissions}
      onChange={onChange}
      value={value}
      defaultValue={!isArray ? defaultValue : value}
    />
  );
});

export default React.memo(CustomField);
